import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface Admin {
  email: string
  role: string
  _id?: string
  id?: string
}

interface AuthState {
  admin: Admin | null
  accessToken: string | null
  isAuthenticated: boolean
  loginTimestamp: number | null
  setAuth: (admin: Admin, token: string) => void
  logout: () => void
  setToken: (token: string) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      admin: null,
      accessToken: null,
      isAuthenticated: false,
      loginTimestamp: null,
      setAuth: (admin: Admin, token: string) =>
        set({
          admin,
          accessToken: token,
          isAuthenticated: true,
          loginTimestamp: Date.now(),
        }),
      logout: () =>
        set({
          admin: null,
          accessToken: null,
          isAuthenticated: false,
          loginTimestamp: null,
        }),
      setToken: (token: string) =>
        set({
          accessToken: token,
        }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        admin: state.admin,
        accessToken: state.accessToken,
        isAuthenticated: state.isAuthenticated,
        loginTimestamp: state.loginTimestamp,
      }),
    }
  )
) 